export default "__VITE_ASSET__BV8Ees2W__"